<script>
const sidebarMenu = [
  { path: '/account', icon: 'fa fa-users', title: 'ui.member_management', pages: [config.accessRoles.account, config.accessRoles.editAccount, config.accessRoles.subAccount, config.accessRoles.editOperatorLimit, config.accessRoles.editIp],
    children: [
      { path: '/newAccount', title: 'ui.new_account', pages: [config.accessRoles.editAccount] },
      { path: '/accountList', title: 'ui.account_list', pages: [config.accessRoles.account] },
      { path: '/subAccount', title: 'ui.sub_account', pages: [config.accessRoles.subAccount] },
      { path: '/ipSettings', title: 'ui.ip_settings', pages: [config.accessRoles.editIp] },
      { path: '/editBetLimit', title: 'ui.bet_limit', pages: [config.accessRoles.editOperatorLimit] }
    ]
  },
  { path: '/report', icon: 'fa fa-list-alt', title: 'ui.report', pages: [config.accessRoles.report],
    children: [
      { path: '/dailyWinlose', title: 'ui.daily_winlose_details', pages: [config.accessRoles.report] },
      { path: '/dailyWinloseByMatch', title: 'ui.daily_winlose_match', pages: [config.accessRoles.report] },
      { path: '/dailyWinloseByPlatform', title: 'ui.daily_winlose_platform', pages: [config.accessRoles.report] },
      { path: '/gameResult', title: 'ui.game_result', pages: [config.accessRoles.report] },
      // { path: '/dailyStatementMember', title: 'ui.daily_statement', pages: [config.accessRoles.report] },
      { path: '/cancelledBetList', title: 'ui.cancelled_bet_list', pages: [config.accessRoles.report] },
      { path: '/settlementHistory', title: 'ui.transfer_history', pages: [config.accessRoles.report] },
      { path: '/matchResult', title: 'ui.match_result', pages: [config.accessRoles.report] },
      { path: '/systemParlay', title: 'ui.system_parlay', pages: [config.accessRoles.report] },
      { path: '/tournamentRefundList', title: 'ui.tournament_refund_list', pages: [config.accessRoles.report] },
      { path: '/dailyWinloseTournament', title: 'ui.op_tournament', pages: [config.accessRoles.report] },
    ]
  },
  { path: '/stock', icon: 'fa fa-star', title: 'ui.total_bet', pages: [config.accessRoles.stock],
    children: [
      { path: '/betListHDPOU', title: 'ui.hdpou', pages: [config.accessRoles.stock] },
      { path: '/betListOXTOEML', title: 'ui.oxtoeml', pages: [config.accessRoles.stock] },
      { path: '/betListCS', title: 'ui.correct_score', pages: [config.accessRoles.stock] },
      { path: '/betListTG', title: 'ui.total_goal', pages: [config.accessRoles.stock] },
      { path: '/betListHTFT', title: 'ui.htft', pages: [config.accessRoles.stock] },
      { path: '/betListDC', title: 'ui.double_chance', pages: [config.accessRoles.stock] },
      { path: '/betListFGLG', title: 'ui.fglg', pages: [config.accessRoles.stock] },
      { path: '/betList', title: 'ui.bet_list', pages: [config.accessRoles.stock] },
      { path: '/memberOutstanding', title: 'ui.member_outstanding', pages: [config.accessRoles.stock] }
    ]
  },
  { path: '/logs', icon: 'fa fa-hdd', title: 'ui.logs', pages: [config.accessRoles.log],
    children: [
      { path: '/betLimitLog', title: 'ui.bet_limit_log', pages: [config.accessRoles.log] }
    ]
  },
  { path: '/tournament', icon: 'fa fa-trophy', title: 'ui.tournament', pages: [config.accessRoles.tournament],
    children: [
      { path: '/tournamentMatch', title: 'ui.tournament_match', pages: [config.accessRoles.tournament] }
    ]
  }

]
import config from "@/config";
export default sidebarMenu;
</script>
